import { gql, useMutation } from '@apollo/client';

import { GET_CONSULTANT_NUMBER_BY_ID } from './get-consultant-number-by-id.hook';
import { GET_CONSULTANT_NUMBERS } from './get-consultant-numbers.hook';

export const UPDATE_CONSULTANT_NUMBER = gql`
  mutation updateConsultantNumber($payload: UpdateConsultantNumberInput!) {
    updateConsultantNumber(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateConsultantNumber = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateConsultantNumber] = useMutation(UPDATE_CONSULTANT_NUMBER, {
    refetchQueries: [GET_CONSULTANT_NUMBERS, GET_CONSULTANT_NUMBER_BY_ID],
    onCompleted: onSuccess,
  });

  return { updateConsultantNumber };
};
